import { Route } from '@angular/router';
import { filters } from './filters';
import { areas } from './areas';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../../sb-routing-enum';
import { attachmentExplorer } from './attachment-explorer';
import { weeklySchedules } from './weekly-cycle';

export const applicationdata: Route = {
  path: 'applicationdata',
  title: 'nav.applicationData',
  data: {
    icon: SbIcons.usbDevice,
    breadcrumb: 'nav.applicationData',
  },
  children: [
    areas,
    filters,
    // attachmentExplorer,
    weeklySchedules,
    { path: '', redirectTo: RoutingID.filters, pathMatch: 'full' },
  ],
};
